import { render, staticRenderFns } from "./VisitDetail.vue?vue&type=template&id=0bfa8db6&"
import script from "./VisitDetail.vue?vue&type=script&lang=js&"
export * from "./VisitDetail.vue?vue&type=script&lang=js&"
import style0 from "./VisitDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports